const drepProd = 'https://webapi.drep.org/api'
const drepTest = 'https://test-web.drep.org/api'
// const apiAddress = window.location.hostname.indexOf('drep.org') !== -1?drepProd:drepTest
// const apiAddress = drepProd
export default drepProd